/**
 * Landing + staff dashboard surfaces.
 * Visual direction from UI/UX Pro Max (glass, hero + CTA, dense KPIs),
 * mapped onto Modern Material Enterprise tokens — not the generic blue/orange palette.
 */
import { getMm } from "./modernMaterialEnterprise";

export function getFocusVisibleSx(isDarkMode) {
  const mm = getMm(isDarkMode);
  return {
    "&:focus-visible": {
      outline: `2px solid ${mm.secondary}`,
      outlineOffset: 2,
    },
  };
}

export function getMotionTransition(
  property = "border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, transform 0.2s ease"
) {
  return {
    transition: property,
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
      transform: "none",
    },
  };
}

export function getGlassSurfaceSx(isDarkMode, { elevated = false } = {}) {
  const mm = getMm(isDarkMode);
  return {
    backgroundColor: isDarkMode ? "rgba(43, 41, 48, 0.78)" : "rgba(255, 255, 255, 0.78)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.10)" : mm.outlineVariant}`,
    boxShadow: elevated ? mm.elev2 : mm.elev1,
  };
}

export function getHeroGradient(isDarkMode) {
  return isDarkMode
    ? "linear-gradient(145deg, #2B2930 0%, #004F4F 78%, #0B6E6E 100%)"
    : "linear-gradient(145deg, #1C1B1F 0%, #0B6E6E 100%)";
}

export function getLandingKpiTint(isDarkMode, variant = "primary") {
  const mm = getMm(isDarkMode);
  const map = {
    primary: {
      bg: isDarkMode ? "rgba(132, 212, 211, 0.16)" : "#E6F6F6",
      fg: mm.secondary,
    },
    success: {
      bg: isDarkMode ? "rgba(132, 212, 211, 0.14)" : "#ECFDF5",
      fg: isDarkMode ? "#86EFAC" : "#047857",
    },
    warning: {
      bg: isDarkMode ? "rgba(245, 158, 11, 0.18)" : "#FFFBEB",
      fg: isDarkMode ? "#FCD34D" : "#B45309",
    },
    accent: {
      bg: isDarkMode ? "rgba(255, 179, 179, 0.16)" : "#FDECEC",
      fg: mm.tertiary,
    },
  };
  return map[variant] || map.primary;
}

export function getInteractiveCardSx(isDarkMode, { clickable = false } = {}) {
  const mm = getMm(isDarkMode);
  return {
    ...getGlassSurfaceSx(isDarkMode),
    ...getMotionTransition(),
    ...getFocusVisibleSx(isDarkMode),
    cursor: clickable ? "pointer" : "default",
    ...(clickable
      ? {
          "&:hover": {
            borderColor: mm.secondary,
            boxShadow: mm.elev2,
            backgroundColor: isDarkMode ? "rgba(43, 41, 48, 0.9)" : "rgba(255, 255, 255, 0.92)",
          },
        }
      : {}),
  };
}
